export default __webpack_public_path__ + "static/media/icon-usd.e743bcbc.svg";